/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Confirmation_TitleInputs */

const en_cas_confirmation_title = /** @type {(inputs: Cas_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Cas_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_confirmation_title = /** @type {((inputs?: Cas_Confirmation_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Confirmation_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_confirmation_title(inputs)
});